import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { LanguageService } from "libraries/service/language/language.service";

/**
 * Use Moment.js to display date
 * Reason : angular2 moment.js has errors in IE or FF
 * Reason2: We have to display UTC format, not browser local
 */
@Pipe({ name: 'timeMoment' })
export class TimeMomentPipe implements PipeTransform {

    constructor(private readonly languageService: LanguageService){}

    /**
     * @param date date value
     * @param timeFormat how to display date
     * "momentTime": "HH:mm"
     * "momentMedium":"ddd DD MMM YYYY",
     * "momentShort":"DD/MM/YYYY"
     */
    public transform(date: string|Date, timeFormat: string): string {
        const language: string = this.languageService.getUserLanguage();
        moment.locale(language);

        return moment(`${moment().format("YYYY-MM-DD")}T${date}`).format(timeFormat || "HH:mm");
    }
}
